import CalendarSchedulesController from './calendar_schedules_controller';
import humps from 'humps';
import Swal from 'sweetalert2';

export default class extends CalendarSchedulesController {
  static targets = [
    'scheduleModalMask',
    'form',
    'agenda',
    'inputDate',
    'selectService',
    'selectProfessor',
    'selectLocation',
    'scheduleLocation',
    'scheduleProfessor',
    'scheduleTime',
    'modalEditActions',
    'filterSelectedSchedules'
  ];
  static values = {
    service: Object,
    locations: Array,
    selectedSchedules: Array,
    maxSchedules: Number,
    keepSelection: Boolean
  };

  connect() {
    this.element.querySelectorAll('.table-row .table-cell').forEach(($tableCell) => {
      $tableCell.addEventListener('click', (ev) => {
        ev.target.classList.contains('table-cell-container') && this.prepareToSelectSchedule($tableCell);
      });
    });

    this.hasSelectLocationTarget && this.selectLocationTarget.addEventListener('change', () => {
      this.selectedSchedule.locationId = this.selectLocationTarget.value;
      this.selectedSchedule.locationName = +this.selectLocationTarget.value > 0 ? this.selectLocationTarget.options[this.selectLocationTarget.selectedIndex].text : '-';
      !!this.selectedCard && (this.selectedCard.querySelector('.title').innerHTML = +this.selectLocationTarget.value > 0 ? this.selectLocationTarget.options[this.selectLocationTarget.selectedIndex].text : 'Novo Horário');
    });
    this.hasSelectProfessorTarget && this.selectProfessorTarget.addEventListener('change', () => this.agendaTarget.querySelectorAll('.card.selected-schedule input[name*=professor]').forEach(($el) => $el.value = this.selectProfessorTarget.value));
    this.hasSelectServiceTarget && this.hasFormTarget && $(this.selectServiceTarget).on('change', () => this.updateCalendar());
    this.scheduleTimeTarget.querySelectorAll('input.time-input').forEach(($input) => $input.addEventListener('change', () => this.onUpdateTimeInput()));
    this.printOutputSelectedSchedules();
    this.initializeCardProperties();
    this.initializeCalendarBindings();
  }

  updateCalendar() {
    this.formTarget.insertAdjacentHTML('afterBegin', '<button class="d-block" id="submit-calendar-schedule-form"></button>');
    this.formTarget.querySelector('#submit-calendar-schedule-form').click();
  }

  saveSchedule(ev) {
    this.selectedCard.schedule = this.selectedSchedule;
    let replaceCard = this.selectedCard.schedule.startTime != this.scheduleTimeTarget.querySelector('input[name="time_start"]').value;
    this.selectedCard.schedule.startTime = this.scheduleTimeTarget.querySelector('input[name="time_start"]').value;
    this.selectedCard.schedule.endTime = this.scheduleTimeTarget.querySelector('input[name="time_end"]').value;
    this.updateSelectedSchedules('.card.selected-schedule');
    this.appendSchedule();
    this.closeScheduleModal(ev);

    if (replaceCard) {
      let column = this.agendaTarget.querySelector(`.table-row[data-time="${+this.selectedCard.schedule.startTime.substring(0, 2)}"] .table-cell[data-day-index="${this.selectedCard.schedule.weekDay}"]`);
      column.querySelector('.table-cell-container').insertAdjacentElement('beforeEnd', this.selectedCard);
    }
  }

  removeSchedule() {
    this.closeModal(() => {
      this.selectedCard.remove();
      this.updateSelectedSchedules('.card.selected-schedule');
    });
  }

  removeDraftSchedules() {
    this.element.querySelectorAll('.card.draft').forEach(($card) => {
      $card.style.width = '0px';
      $card.style.opacity = '0';
      setTimeout(() => $card.remove(), 100);
    });
  }

  openCard($card) {
    this.selectedCard = $card;
    this.selectedSchedule = $card.schedule;
    this.modalEditActionsTarget.classList.remove('hidden');
    setTimeout(() => this.openModalSchedule(), 200);
  }

  prepareToSelectSchedule($cell) {
    if (!this.canOpenToSelectSchedule())
      return;

    this.selectedSchedule = {
      startTime: $cell.dataset.startTime,
      endTime: $cell.dataset.endTime,
      dayName: $cell.dataset.dayName,
      dayShort: $cell.dataset.dayShort,
      weekDay: $cell.dataset.dayIndex,
      date: $cell.dataset.date,
      serviceId: this.selectServiceTarget.value,
      professorId: this.selectProfessorTarget.value,
      professorName: this.selectProfessorTarget.selectedOptions[0].innerText,
      locationId: (this.hasSelectLocationTarget ? this.selectLocationTarget.value : undefined),
      appendUID: !!this.element.dataset.appendUid ? this.element.dataset.appendUid === 'true' : true
    };
    this.selectedCard = this.insertDraftSchedule($cell);
    this.selectedCard.addEventListener('click', (ev) => this.openCard(ev.currentTarget));
    this.modalEditActionsTarget.classList.add('hidden');
    setTimeout(() => this.openModalSchedule(), 100) // wait animations end
  }

  canOpenToSelectSchedule() {
    let selectedSchedulesCount = this.agendaTarget.querySelectorAll('.card.selected-schedule').length;
    if (selectedSchedulesCount + 1 > this.maxSchedulesValue) {
      return Swal.fire({
        title: 'Atenção',
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        html: 'Todos os horários necessários já estão selecionados. <br> Caso queira substituir, remova algum outro horário primeiro.',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }) && false;
    }

    return true;
  }

  insertDraftSchedule($cell) {
    return this.insertCard($cell, 'open draft', `${this.selectProfessorTarget.selectedOptions[0].innerText.split(' ')[0]} - Novo`);
  }

  insertCard($cell, cssStyle, title = 'Novo') {
    let uid = `id-${new Date().getTime() + Math.ceil(Math.random() * 10)}`;

    $cell.querySelector('.table-cell-container').insertAdjacentHTML('beforeEnd', `
      <div class="card selected-schedule ${cssStyle}" id="${uid}">
        <div class="content">
          <div class="content-container">
            <div class="line-clamp-1 title">${title}</div>
            <div class="time">${$cell.dataset.startTime} às ${$cell.dataset.endTime}</div>
          </div>
        </div>
      </div>
    `);

    return $cell.querySelector(`#${uid}`);
  }

  openModalSchedule() {
    this.prepareScheduleFields();
    this.prepareModalToAnimation();
    this.scheduleModalMaskTarget.classList.add('show');
    document.querySelector('.schedule-mask').style.removeProperty('z-index');
  }

  prepareScheduleFields() {
    this.scheduleTimeTarget.querySelector('.week-day-name').innerHTML = this.selectedSchedule.dayShort;
    this.scheduleTimeTarget.querySelector('input[name="time_start"]').value = this.selectedSchedule.startTime;
    this.scheduleTimeTarget.querySelector('input[name="time_end"]').value = this.selectedSchedule.endTime;
    this.scheduleProfessorTarget.innerHTML = this.selectProfessorTarget.selectedOptions[0].innerHTML;
    this.hasSelectLocationTarget && (this.scheduleLocationTarget.innerHTML = (+this.selectLocationTarget.value > 0 ? this.selectLocationTarget.selectedOptions[0].innerHTML : '-'));
  }

  onUpdateTimeInput() {
    this.selectedCard.querySelector('.time').innerHTML = `${this.scheduleTimeTarget.querySelector('input[name="time_start"]').value} às ${this.scheduleTimeTarget.querySelector('input[name="time_end"]').value}`;
  }

  printOutputSelectedSchedules() {
    if (this.selectedSchedulesValue.length == 0)
      return;

    humps.camelizeKeys(this.selectedSchedulesValue).forEach(function(schedule) {
      this.selectedSchedule = schedule;
      console.log({ schedule })
      this.selectedSchedule.appendUID = true;
      let row = this.agendaTarget.querySelector(`.table-row[data-time="${+schedule.startTime.substring(0, 2)}"]`),
        column = row.querySelector(`.table-cell[data-day-index="${schedule.weekDay}"]`),
        card = this.insertCard(column, '', `<i class="fas fa-user-tie text-xs"></i> ${schedule.professorName.split(' ')[0]} - ${typeof schedule.locationName === 'string' && schedule.locationName.length > 0 ? schedule.locationName : 'Selecionado'}`);

      card.schedule = schedule;
      this.selectedCard = card;
      card.addEventListener('click', (ev) => this.openCard(ev.currentTarget));
      this.appendSchedule();
    }.bind(this));

    this.updateSelectedSchedules('.card.selected-schedule');
  }

  submitForm() {
    let form = this.element.closest('form');
    !!this.keepSelectionValue && this.keepSelectedSchedules();
    form.insertAdjacentHTML('afterBegin', '<button id="submit-button" class="d-none"></button>');
    form.querySelector('#submit-button').click();
  }

  keepSelectedSchedules() {
    let schedules = [];
    this.agendaTarget.querySelectorAll('.card.selected-schedule').forEach((it) => schedules.push(it.schedule));
    this.element.closest('form').insertAdjacentHTML('beforeEnd', `<input type="hidden" name="selected_schedules" value='${JSON.stringify(schedules)}' />`);
  }

  get zIndex() {
    let closestModal = this.element.closest('.modal');
    if (!closestModal) return 6;

    return +getComputedStyle(closestModal).zIndex + 10;
  }

  get allowedKey() {
    return ['startTime', 'endTime', 'weekDay', 'professorId', 'locationId', 'date', 'serviceId'];
  }
}